import { memo } from 'react'

import { Box, type LargeIcon, Section } from '@factorialco/deprecated-design-system'
import {
  SecuritySettingsSamlSetupModalDomainFragment,
  SecuritySettingsSsoEnforcementEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import SsoEnforcementForm from 'modules/security_settings/pages/SecuritySettingsPage/SsoSection/SsoEnforcementForm'

import SamlBlock from './SamlBlock'

interface Props {
  domains: SecuritySettingsSamlSetupModalDomainFragment[]
  ssoEnforcement: SecuritySettingsSsoEnforcementEnum
}

function SsoSection({ domains, ssoEnforcement }: Props) {
  // FIXME: For the sections we're using the gamma <Section> component until <Title> and the new
  // <ResponsivePage> are available... since the old sections need to have an illustration, we'll
  // pass a fake one for now (which makes it not show any icon)
  const noIllustration = 'NO_ICON' as LargeIcon

  // The icon is not visible, but it still takes up space in the section's left column, so we need
  // to add some extra padding to the content to keep it aligned.
  const contentExtraTopPadding = 's48'

  return (
    <Section.TwoThirds
      title={i18n.t('security_settings.sso.title')}
      description={i18n.t('security_settings.sso.description')}
      illustration={noIllustration}
    >
      <Box paddingTop={contentExtraTopPadding} gap="s12">
        <SamlBlock domains={domains} />
        <SsoEnforcementForm ssoEnforcement={ssoEnforcement} />
      </Box>
    </Section.TwoThirds>
  )
}

export default memo(SsoSection)
